module.exports = __webpack_public_path__ + "img/icon-16-ic-online-small.c4273f0a.svg";